import {
  AppCustomizableItems,
  FormAppCustomizableItems,
} from '@/modules/customization/entities/interfaces/customizations.interfaces';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';
import { turnIntoFormData } from '@/utils/turnIntoFormData';
import removeEmptyParams from '@/utils/removeEmptyParams';

export class AppCustomizationService extends HttpClientAdapter {
  constructor() {
    super('SYSTEM');
  }

  showAppCustomizationByCompanyCnpj(companyCnpj: string) {
    return this.get<AppCustomizableItems>(`/systems/app/companies/${companyCnpj}/customizations`);
  }

  createAppCustomizationByCompanyCnpj(
    companyCnpj: string,
    formAppCustomizableItems: Partial<FormAppCustomizableItems>,
  ) {
    return this.post<AppCustomizableItems>(
      `/systems/app/companies/${companyCnpj}/customizations`,
      turnIntoFormData(removeEmptyParams(formAppCustomizableItems)),
    );
  }

  updateAppCustomizationById(
    customizationId: string,
    formAppCustomizableItems: Partial<FormAppCustomizableItems>,
  ) {
    return this.patch<FormData, AppCustomizableItems>(
      `/systems/app/customizations/${customizationId}`,
      turnIntoFormData(removeEmptyParams(formAppCustomizableItems, [null, undefined])),
    );
  }
}
